export default {
  toasts: {
    verification_pending: 'Votre vérification est toujours en attente',
  },
};
